<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'complianceRelatedServiceModule';

export default {
  name: 'WrapperComplianceRelatedService',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
